import React from 'react';
import PropTypes from 'prop-types';
import FullScreenModal from 'components/consumer/FullScreenModal';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import withLoginPage from 'components/consumer/consumer-login/login-page/hoc/withLoginPage';
import OrderSummary from './OrderSummary';

const OrderDetailsModal = ({ isOpen, onClose, orderId }) => (
    <FullScreenModal isOpen={isOpen} onClose={onClose}>
      <FixedWidthContainer>
        <OrderSummary order_id={orderId} />
      </FixedWidthContainer>
    </FullScreenModal>
  );

OrderDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  orderId: PropTypes.string,
};

export default withLoginPage(OrderDetailsModal);
